import {inject, Injectable} from '@angular/core';
import {CurrencyPipe} from '@angular/common';
import {DEFAULT_CURRENCY} from "../../../../config/app.config";
import {Wallet} from "@features/wallet/domain/model/wallet.model";
import {WalletWidgetViewModel} from "@features/wallet/application/view-models/wallet-widget.view-model";

@Injectable({providedIn: 'root'})
export class WalletWidgetMapper {
  private readonly currencyPipe = inject(CurrencyPipe);

  public toVM(wallet?: Wallet): WalletWidgetViewModel {
    const available = wallet?.availableBalance ?? 0;
    const currency = wallet?.currency ?? DEFAULT_CURRENCY;

    return {
      balance: this.currencyPipe.transform(available, currency) ?? `${available} ${currency}`,
    };
  }
}
